<div (click)="onMenuItemSelected(menuItem)" class="search-result-item" [ngClass]="getSearchResultItemActiveClass">
  @if (parent) {
    <a (click)="triggerMenuItemClick($event,menuItemComponent)" class="path" [title]="parent" href="#">
      <span [ngClass]="getParentIcon()"></span>
      <span class="path-title" [innerText]="parent"></span>
    </a>
  }
  <scitis-menu-item #menuItemComponent [menuItem]="menuItem" [fireMenuItemSelectAction]="false"
    class="scitis-menu-item">
  </scitis-menu-item>
</div>
